import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "utils";
import { NOTIFICATION_TYPE, NotificationApi } from "api/notifications";
import { htmlParser } from "utils/htmlParser";
import { routes } from "consts";

interface NotificationItemProps {
  notification: NotificationApi;
  onMouseEnter?: () => void;
  onItemClick?: () => void;
  onMouseLeave?: () => void;
}

export function NotificationItem({ onItemClick, notification, onMouseLeave, onMouseEnter }: NotificationItemProps) {
  return (
    <li
      key={notification.id}
      className="border-b border-gray-200 last:border-0 dark:border-gray-700/60"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Link
        className="relative block px-4 py-2 hover:bg-gray-50 dark:hover:bg-gray-700/20"
        to={resolveLink(notification)}
        onClick={onItemClick}
      >
        <span className="mb-2 block text-sm">
          {!notification.isRead && "📣 "}
          {htmlParser.toHTML(notification.message)}
        </span>
        <span className="block text-xs font-medium text-gray-400 dark:text-gray-500">
          {formatDate(notification.notificationDate, true, true)}
        </span>
        <div className="bg-primary-500 absolute right-1 top-[50%] h-2.5 w-2.5 rounded-full border-2 border-gray-100 opacity-60 dark:border-gray-900"></div>
      </Link>
    </li>
  );
}

export const resolveLink = (notification: NotificationApi) => {
  if (notification.type === NOTIFICATION_TYPE.COURSE_TRANCHE_PAID && notification.relatedCourseId)
    return routes.STUDENT_NESTED.PAYMENTS(notification.relatedUserId, notification.relatedCourseId);
  if (notification.type === NOTIFICATION_TYPE.COURSE_REGISTERED && notification.relatedCourseId)
    return routes.COURSES_MANAGE_NESTED.STUDENTS(notification.relatedCourseId);
  if (notification.type === NOTIFICATION_TYPE.COURSE_CANCELLATION_REQUESTED && notification.relatedCourseId)
    return routes.STUDENT_NESTED.ACTIONS(notification.relatedUserId, notification.relatedCourseId);
  if (notification.type === NOTIFICATION_TYPE.TRAINER_AVAILABILITY_MARKED && notification.relatedTrainerId)
    return routes.TRAINER(notification.relatedTrainerId);

  return "#0";
};
